export default __webpack_public_path__ + "static/media/dcc32202eb95897dfce0fba3709f57a.39e8a545.png";